import React from 'react';
import PropTypes from 'prop-types';

const Comment = ({ fill = 'var(--PRIMARY)' }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Transactions-Disputes-01"
        transform="translate(-1364.000000, -321.000000)"
        fill={fill}
        fillRule="nonzero"
      >
        <g id="Group-7" transform="translate(265.000000, 258.000000)">
          <g id="Group-5" transform="translate(1091.000000, 58.000000)">
            <g id="Cross-White" transform="translate(8.000000, 5.000000)">
              <g id="message">
                <path
                  d="M9,0.63 C13.6261786,0.63 17.37,4.37401875 17.37,9 C17.37,13.6261786 13.6259812,17.37 9,17.37 C7.63806458,17.37 6.30416154,17.0403639 5.10701073,16.410553 L4.9401,16.3179 L1.80956213,17.3264933 C1.55814096,17.4073949 1.28870938,17.373238 1.06901936,17.2417036 L0.978109422,17.1794213 L0.894475456,17.1055245 C0.681610067,16.8926592 0.590542503,16.5897964 0.645867702,16.2987647 L0.67352485,16.1903813 L1.6812,13.059 L1.58944705,12.8929893 C1.06093439,11.8883872 0.743802091,10.7874854 0.655459722,9.65452976 L0.635838119,9.31374569 L0.63,9 C0.63,4.37382139 4.37401875,0.63 9,0.63 Z M9,2.435625 C5.38066902,2.435625 2.435625,5.38066902 2.435625,9 C2.435625,10.2326916 2.77945991,11.4340094 3.42994983,12.4744372 C3.55082943,12.6678446 3.5933611,12.898551 3.55172659,13.1200325 L3.52386856,13.2297892 L2.9313,15.0678 L4.77024604,14.4761201 C4.98816177,14.4059743 5.22230329,14.4218069 5.42632845,14.5162324 L5.52561679,14.5699603 C6.56595692,15.2205142 7.7672588,15.564375 9,15.564375 C12.619331,15.564375 15.564375,12.619331 15.564375,9 C15.564375,5.38066902 12.619331,2.435625 9,2.435625 Z M9,8 C9.55232874,8 10,8.44767126 10,9 C10,9.55224635 9.55229467,10 9,10 C8.44770533,10 8,9.55224635 8,9 C8,8.44767126 8.44767126,8 9,8 Z M12,8 C12.5523287,8 13,8.44767126 13,9 C13,9.55224635 12.5522947,10 12,10 C11.4477053,10 11,9.55224635 11,9 C11,8.44767126 11.4476713,8 12,8 Z M6,8 C6.55232874,8 7,8.44767126 7,9 C7,9.55224635 6.55229467,10 6,10 C5.44778774,10 5,9.55221226 5,9 C5,8.44770533 5.44775365,8 6,8 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Comment.propTypes = {
  fill: PropTypes.string,
};

export default Comment;
